import { render, staticRenderFns } from "./PrizesWidget.vue?vue&type=template&id=e6dbb3c6&"
import script from "./PrizesWidget.vue?vue&type=script&lang=js&"
export * from "./PrizesWidget.vue?vue&type=script&lang=js&"
import style0 from "./PrizesWidget.vue?vue&type=style&index=0&id=e6dbb3c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports